import { useTranslation } from 'react-i18next'
import React from 'react'

import { usePlaceAvailability } from '../_load/PlaceAvailabilityLoader'
import LabelValue from '../../../../components/presentation/LabelValue'
import OpenNonCompliancesList from './openNonCompliances/OpenNonCompliancesList'
import OpenNonCompliancesLoader from './openNonCompliances/_load/OpenNonCompliancesLoader'
import Separator from '../../../../components/helpers/Separator'
import { Title } from '../../../../components/presentation/Text'

const Details = () => {
  const { t } = useTranslation('availability')
  const place = usePlaceAvailability()

  return (
    <>
      <Separator weight={2} />

      <LabelValue label={t('place')} children={place.resume || place.name} />

      <Separator weight={4} />

      <Title size="h6" bold color="dark2">
        {t('openNonCompliancesList.title')}
      </Title>
      <Separator weight={2} />

      <OpenNonCompliancesLoader placeId={place.id}>
        <OpenNonCompliancesList />
      </OpenNonCompliancesLoader>
    </>
  )
}

export default Details
